<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M18.75 2H5.25C3.46 2 2 3.46 2 5.25v13.5C2 20.54 3.46 22 5.25 22h13.5c1.79 0 3.25-1.46 3.25-3.25V5.25C22 3.46 20.54 2 18.75 2Zm-8.16 10-1.97 1.97L6.65 12l1.97-1.97L10.59 12Zm-.56-3.38L12 6.65l1.97 1.97L12 10.59l-1.97-1.97ZM12 13.41l1.97 1.97L12 17.35l-1.97-1.97L12 13.41ZM13.41 12l1.97-1.97L17.35 12l-1.97 1.97L13.41 12Zm3.39-3.38 3.2-3.2v3.94l-1.23 1.23-1.97-1.97ZM15.38 7.2l-1.97-1.97L14.64 4h3.94l-3.2 3.2Zm-4.79-1.97L8.62 7.2 5.42 4h3.94l1.23 1.23ZM7.2 8.62l-1.97 1.97L4 9.36V5.42l3.2 3.2ZM4 14.64l1.23-1.23 1.97 1.97-3.2 3.2v-3.94Zm4.62 2.16 1.97 1.97L9.36 20H5.42l3.2-3.2Zm4.79 1.97 1.97-1.97 3.2 3.2h-3.94l-1.23-1.23Zm3.39-3.39 1.97-1.97L20 14.64v3.94l-3.2-3.2Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
